<template>
  <div>
      <!-- <v-subheader>Actions</v-subheader>
      <v-list-item link to="/users">
        <v-list-item-icon>
          <v-icon>mdi-account</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Users</v-list-item-title>
      </v-list-item>
      <v-list-item link to="/apps">
        <v-list-item-icon>
          <v-icon>mdi-application</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Apps</v-list-item-title>
      </v-list-item> -->
  </div>
  </div>
</template>

<script>

export default {
  name: 'MitMenuManager',
  components: {
  },
  props: {
    userModel: Object
  }
}
</script>

<style lang="scss" scoped>
</style>
